import React from 'react';
import PropTypes from 'prop-types';
import style from './arrow.css';
import { classNames } from '../../utils/utils';

/**
 * 表格箭头
 * @param { 'desc' | 'asc' } props.highlight: 高亮
 */
const Arrow = function Arrow(props) {
    const { highlight } = props;

    return (
        <div className={style.box}>
            <div className={classNames(style.arrowTop, highlight === 'asc' ? style.highlight : undefined)} />
            <div className={classNames(style.arrowBottom, highlight === 'desc' ? style.highlight : undefined)} />
        </div>
    );
};

Arrow.propTypes = {
    highlight: PropTypes.string,
};

export default Arrow;
